import { APIClient } from "api/apiCore";
import TextBox from "components/TextBox";
import { Utils } from "helpers/utils";
import React, { useDeferredValue, useEffect, useState } from "react";
import * as urls from "../../../api/urls";
import Select, { components, OptionProps, SingleValueProps } from 'react-select';
import DatePicker from "react-datepicker";
import AutoTextArea from "components/AutoTextArea";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { RecuranceModes } from "const";
import DatePickerEx from "components/DatePickerEx";
import DateTimePickerEx from "components/DateTimePickerEx";
import { FormCheck, FormControl } from "react-bootstrap";
import TimePickerEx from "components/TimePickerEx";

import SelectDropdownWeekDay from "components/SelectDropdownWeekDay";
import SelectDropdownMonth from "components/SelectDropdownMonth";
import SelectDropdownDay from "components/SelectDropdownDay";
import { TaskRecurance2Data, TaskRecurance2DataDef } from "types";


interface RecuranceControl2Props {
  data?: TaskRecurance2Data | null;
  // onDataChanged?: (data: TaskRecurance2Data) => void;
  onPartialChanged?: (patch: Partial<TaskRecurance2Data>) => void;
}

const RecuranceControl2 = ({ onPartialChanged, data = TaskRecurance2DataDef() }: RecuranceControl2Props) => {

  // const [data, setData] = useState<TaskRecuranceDtlData>(() => initData ?? { recuranceMode: RecuranceModes.None });

  const updateData = (patch: Partial<TaskRecurance2Data>) => {
    onPartialChanged?.(patch);
    // setData(prev => {
    //   const next = { ...prev, ...patch };
    //   onDataChanged?.(next);
    //   return next;
    // });
  }

  // useEffect(() => {
  //   console.log('data:', data);
  // }, [data]);
  // console.log('data!.specificDate:', data!.specificDate);
  const n2s = (nums: number[] | null): string => {
    return Utils.Numbers2String(nums);
  }

  const s2n = (str: string | null | undefined): number[] | undefined => {
    return Utils.String2Numbers(str);
  }

  const fnFreqText = () => {
    return Utils.GetTaskRecuranceFreqText(data!);
  }

  return (
    <>
      <div className="row">
        <div className="col-4">
          <RadioGroup row={false} value={data!.recuranceMode} onChange={(e) => updateData({ recuranceMode: e.target.value as RecuranceModes })}>
            {/* <FormControlLabel value={RecuranceModes.None} control={<Radio />} label="ไม่มี"></FormControlLabel> */}
            <FormControlLabel value={RecuranceModes.OneTime} control={<Radio />} label="ระบุวันเวลา"></FormControlLabel>
            <FormControlLabel value={RecuranceModes.Daily} control={<Radio />}
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  ทุก
                  <select className="form-control w-auto " style={{ paddingBottom: "2px", paddingTop: "2px" }} value={(data?.freqDay ?? 1).toString()} onChange={(e) => updateData({ freqDay: Utils.ToNumber(e.target.value, 1) })}>
                    {Array.from({ length: 60 }, (_, i) => { return (<option key={i} value={i + 1}>{i + 1}</option>) })}
                  </select>
                  วัน
                </div>
              }
            >
            </FormControlLabel>
            <FormControlLabel value={RecuranceModes.Weekly} control={<Radio />}
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  ทุก
                  <select className="form-control w-auto " style={{ paddingBottom: "2px", paddingTop: "2px" }} value={(data?.freqWeek ?? 1).toString()} onChange={(e) => updateData({ freqWeek: Utils.ToNumber(e.target.value, 1) })}>
                    {Array.from({ length: 10 }, (_, i) => { return (<option key={i} value={i + 1}>{i + 1}</option>) })}
                  </select>
                  อาทิตย์
                </div>
              }
            ></FormControlLabel>
            <FormControlLabel value={RecuranceModes.Monthly} control={<Radio />}
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  ทุก
                  <select className="form-control w-auto " style={{ paddingBottom: "2px", paddingTop: "2px" }} value={(data?.freqMonth ?? 1).toString()} onChange={(e) => updateData({ freqMonth: Utils.ToNumber(e.target.value, 1) })}>
                    {Array.from({ length: 24 }, (_, i) => { return (<option key={i} value={i + 1}>{i + 1}</option>) })}
                  </select>
                  เดือน
                </div>
              }
            ></FormControlLabel>
            {/* <FormControlLabel value={RecuranceModes.Quarterly} control={<Radio />} label="รายไตรมาส"></FormControlLabel> */}
            <FormControlLabel value={RecuranceModes.Yearly} control={<Radio />}
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  ทุก
                  <select className="form-control w-auto " style={{ paddingBottom: "2px", paddingTop: "2px" }} value={(data?.freqYear ?? 1).toString()} onChange={(e) => updateData({ freqYear: Utils.ToNumber(e.target.value, 1) })}>
                    {Array.from({ length: 12 }, (_, i) => { return (<option key={i} value={i + 1}>{i + 1}</option>) })}
                  </select>
                  ปี
                </div>
              }
            >
            </FormControlLabel>
          </RadioGroup>
        </div>
        <div className="col-8" style={{ borderLeft: "dashed 1px gray" }}>
          <u>{fnFreqText()}</u>
          {data!.recuranceMode === RecuranceModes.OneTime && (
            <div className="d-flex justify-content-start align-items-center" style={{ gap: "8px" }}>
              ระบุวันที่เสร็จ
              <DatePickerEx isDisabled={false} onDateChanged={(date) => updateData({ specificDate: date })} selectedDate={data!.specificDate ?? null} />
            </div>
          )}

          {data!.recuranceMode === RecuranceModes.Daily && (<>
            {/* <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "130px" }}>เสร็จภายใน เวลา</span>
              <TimePickerEx onChange={(e) => updateData({ dailyOnTime: e })} value={data!.dailyOnTime ?? ""} />
            </div> */}
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "130px" }}>ยกเว้น วันที่</span>
              <SelectDropdownDay isDisabled={false} onSelectDay={(days) => updateData({ dailyExceptDay: n2s(days) })} selectedDays={s2n(data!.dailyExceptDay)} />
            </div>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "130px" }}>ยกเว้น วัน</span>
              <SelectDropdownWeekDay isDisabled={false} selectedDays={s2n(data!.dailyExceptWeekDay)} onSelectDays={(days) => updateData({ dailyExceptWeekDay: n2s(days) })} />
            </div>
          </>)}

          {data!.recuranceMode === RecuranceModes.Weekly && (<>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>เสร็จภายใน วัน</span>
              <SelectDropdownWeekDay isDisabled={false} selectedDays={s2n(data!.weeklyEveryWeekDay)} onSelectDays={(days) => updateData({ weeklyEveryWeekDay: n2s(days) })} />
            </div>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>ยกเว้น วันที่</span>
              <SelectDropdownDay isDisabled={false} onSelectDay={(days) => updateData({ weeklyExceptDay: n2s(days) })} selectedDays={s2n(data!.weeklyExceptDay)} />
            </div>
          </>)}

          {data!.recuranceMode === RecuranceModes.Monthly && (<>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>เสร็จภายใน วันที่</span>
              <SelectDropdownDay isDisabled={false} onSelectDay={(days) => updateData({ monthlyEveryDay: n2s(days) })} selectedDays={s2n(data!.monthlyEveryDay)} />
            </div>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>ยกเว้น วัน</span>
              <SelectDropdownWeekDay isDisabled={false} selectedDays={s2n(data!.monthlyExceptWeekDay)} onSelectDays={(days) => updateData({ monthlyExceptWeekDay: n2s(days) })} />
            </div>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>ยกเว้น เดือน</span>
              <SelectDropdownMonth isDisabled={false} selectedMonths={s2n(data!.monthlyExceptMonth)} onSelectMonths={(months) => updateData({ monthlyExceptMonth: n2s(months) })} />
            </div>
          </>)}

          {data!.recuranceMode === RecuranceModes.Yearly && (<>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>เสร็จภายใน วันที่</span>
              <SelectDropdownDay isDisabled={false} onSelectDay={(days) => updateData({ yearlyEveryDay: n2s(days) })} selectedDays={s2n(data!.yearlyEveryDay)} />
            </div>
            <div className="form-row-item">
              <span className="form-label-fix" style={{ width: "120px" }}>ทุก ๆ เดือน</span>
              <SelectDropdownMonth isDisabled={false} selectedMonths={s2n(data!.yearlyEveryMonth)} onSelectMonths={(months) => updateData({ yearlyEveryMonth: n2s(months) })} />
            </div>
          </>)}

        </div>
      </div>
    </>
  );
}/*)*/;

export default RecuranceControl2;